<template>
  <div class="aaa">
        <Loading v-show="loading"></Loading>
    <div class="about-box" v-show="!loading">
      <div class="inbox">
        <h1>使い方</h1>
        <div class="figureabout">
          <img src="../assets2/single.svg" alt="ならんでつかう">
        </div>
        <h2>横に座りながら使います。ボタンを押すとボタンに書いてある平仮名が文字盤の上の白い場所に表示されます。
          「よむ」ボタンを押すと、表示された文字を読み上げることができます。入力を間違えた時は「1もじけす」「ぜんぶけす」のボタンで消せます。</h2>
        <div class ="clear"></div>
        <div class="figureabout">
          <img src="../assets2/single2.svg" alt="むかいあってつかう">
        </div>
        <h2>向かい合わせに座りながら使います。自分の押した文字が相手の方に表示されます。<br>ほタブレットで使ってください。</h2>
        <div class="clear"></div>
        <div class="figureabout">
          <img src="../assets2/stamp.svg" alt="すたんぷ">
        </div>
        <h2>スタンプを押すとスタンプに書いてある文字を読み上げます。文字を入力するのが大変な時に使ってください。</h2>
        <div class ="clear"></div>
        <div class="figureabout">
          <img src="../assets2/camera.svg" alt="つうしん">
        </div>
        <h2>通信は、無料で使えます。1人1つずつのひらがなの合言葉を使って接続します。例えば1人目の人が「ぶどう」、2人目の人が「みかん」だった場合で説明をします。</h2><br>
      </div>
      <div class="howtovideo">
        <h1 class="howtotitle">1人目の人の操作</h1>
        <h2>（1）あらかじめ2人で決めていた自分の合言葉を平仮名で入力して赤い「けってい」ボタンを押して待っていてください。<br>
          <img src="../assets/howto01.png" alt="合言葉1" width="30%" height="30%"><br>
          (2)合言葉の確認がされるので、OKを押します。するとカメラが起動して自分の映像が画面に映ります。通話が始まるまで、しばらく待っていてください。<br>
          <img src="../assets/howto02.png" alt="ポップ1" width="30%" height="30%"><br>
        </h2>
        <h1 class="howtotitle">2人目の人の操作</h1>
        <h2>（1）自分の合言葉を平仮名で入力して赤い「けってい」ボタンを押してください。<br>
          <img src="../assets/howto01.png" alt="合言葉2" width="30%" height="30%"><br>
          (2)合言葉の確認がされるので、OKを押します。するとカメラが起動して自分の映像が画面に映ります。<br>
          <img src="../assets/howto03.png" alt="ポップ2" width="30%" height="30%"><br> 
          (3)相手の合言葉を入力して黒い「けってい」ボタンを押します。<br>
          <img src="../assets/howto04.png" alt="合言葉3" width="30%" height="30%"><br>           
          (4)相手の合言葉の確認がされるので、OKを押します。しばらくするとビデオ通話が始まります。<br>    
          <img src="../assets/chat1.png" alt="チャット画面" width="50%" height="50%">
          <img src="../assets/chat2.png" alt="チャット画面" width="50%" height="50%"></h2>   
      
      <div id="pdf"><h2><a href="https://www.dropbox.com/s/rs6gptvry88r7if/howto.pdf?dl=0">ビデオ通話の使い方のPDF</a>を作りました。印刷すると合言葉を書き込目ます。おじいちゃん、おばあちゃんに渡して使ってください。
        </h2></div>
        
      </div></div>
    <div>※通信部分はAndroid(Chrome）、iPad (safari）で接続を確認しています。<br>ご意見ご感想はこちらに↓</div>
    <div class="critica-container">
      <div class="aaaaa">
      <iframe src="https://critica.uno/224574/iframe"  width="560" height="360" scrolling="no" style="overflow: hidden; width:100%;"></iframe>
      </div>
    </div>



    
  </div>
</template>
  <script type="text/javascript" src="https://minmoji.ucda.jp/sealjs/https%3A__brushtalk-5c0f3.web.app_" charset="UTF-8"></script>
<script>
import Loading from '@/components/Loading'

export default {
  name: 'aaa',
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  components: {
    Loading,
  },
};
</script>

<style scoped>

h2 {
	margin-bottom: 30px;
  margin-right: 100px;
	line-height: 2em;
  text-align: left;
}
.figureabout {
	float: left;
	margin: 0 0px 15px 0;
	width: 25%;
}
figureabout img {
	max-width: 100%;
}
.clear{
	clear: both;
}
.about-box {
  font-size:10px;
  padding: 0.5em 1em;
  margin: 2em 2em;
  background-color: #ccddef;
  border: dashed 2px #4B5B65;/*点線*/
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  /* 記事折り返し設定 */
}
.about-box inbox  {
    margin: 0;
    padding: 10px;
}

@font-face {
    font-family: minmoji;
    src: url('https://minmoji.ucda.jp/fontseot/https%3A__brushtalk-5c0f3.web.app_');
    src: local('minmoji'),
        url('https://minmoji.ucda.jp/fontswoff/https%3A__brushtalk-5c0f3.web.app_') format('woff'),
        url('https://minmoji.ucda.jp/fonts/https%3A__brushtalk-5c0f3.web.app_') format('opentype');
}

iframe{
  margin-left: auto;
  margin-right: auto;
  width: 8em
}

about-box {
    font-family: minmoji;
}

#think{
  font-size: 20px;
}

#pdf{
  text-align: left;
  margin-left:50px;
}

critica-container{
    position:relative;
    width:100%;
    max-height:600px;
    min-height:300px;
    overflow:hidden;
}
.critica-container iframe{
}
.critica-container{
    display: flex;
    justify-content: center;
    align-items: center;
}
.aaaaa{
    display: flex;
    justify-content: center;
    align-items: center;
}
.howtovideo{
  margin-left:70px;
}
.howtotitle{
  text-align:left;
}
</style>